export function androidInputFixed(height, bgDom) {
   const ua = navigator.userAgent
   if(/android/i.test(ua)){
        window.addEventListener('resize',function() {
            bgDom.setAttribute('style','height:'+height+'px')
        })
   }
}




// WEBPACK FOOTER //
// ./src/utils/index.js